import getDOMfromString from '../../../helpers/getDOMfromString';

/**
 * Generates zoom button
 *
 * @param {Object} config - options for btn
 * @returns {HTMLElement|string} - button/button string
 */
const createZoomBtn = config => {
    const {customClasses = [], color = '#fff', onClick, htmlStr = false, iconOnly = false, label} = config ?? {};
    const customClassesStr = Array.isArray(customClasses) ? customClasses.join(' ') : '';
    let elStr = ``;

    const svgStr = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15.8887 8.11133L8.1105 15.8895" stroke="${color}" stroke-width="1.2"/>
            <path xmlns="http://www.w3.org/2000/svg" d="M11.9998 7.75804L16.2425 7.75804L16.2432 12.0014" stroke="${color}" stroke-width="1.2"/>
            <path xmlns="http://www.w3.org/2000/svg" d="M12.0005 16.2439L7.75789 16.2439L7.7572 12.0006" stroke="${color}" stroke-width="1.2"/>
    </svg>`;

    if (iconOnly) {
        elStr = svgStr;
    } else {
        elStr = `<button type="button" aria-haspopup="dialog" aria-controls="app-zoom-modal" aria-label="${label}" title="${label}" class="${customClassesStr}">${svgStr}</button>`;
    }

    if (htmlStr) {
        return elStr;
    }

    // DOM element
    const el = getDOMfromString(elStr);

    if (onClick) {
        el.onclick = onClick;
    }

    return el;
};

export default createZoomBtn;
